export const sanitizeMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return message;
  }
  // Remove phoneme tags but keep the content inside
  // Matches: <phoneme alphabet="ipa" ph="ˈtwɪlioʊ">Twilio</phoneme>
  // and replaces with: Twilio
  let sanitized = message.replace(/<phoneme[^>]*>(.*?)<\/phoneme>/gi, '$1');
  // Remove speak tags but keep the content inside
  // Matches: <speak>text</speak>
  // and replaces with: text
  sanitized = sanitized.replace(/<speak>(.*?)<\/speak>/gi, '$1');
  return sanitized;
};
